import {Component, OnInit} from '@angular/core';
import {ContractsDataService} from '../_services/contracts-data.service';
import {ActivatedRoute} from '@angular/router';
import {ContractModel} from '../_models/contract.model';
import * as fileSaver from 'file-saver';

import pdfMake from 'pdfmake/build/pdfmake';
import {UserLanguages} from '../../../../jobboard/shared/models/userLanguages.model';
import {ProductListModel} from '../_models/productList.model';
import {NotesListModel} from '../_models/notesList.model';
import {EnumTransformPipe} from '../../../../shared-module/enumTransform/enum-transform.pipe';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PaymentObjectModel} from '../_models/paymentObject.model';



@Component({
    selector: 'app-view-contract',
    templateUrl: './view-contract.component.html',
    styleUrls: ['./view-contract.component.scss']
})

// tslint:disable-next-line:component-class-suffix
export class ViewContractComponents implements OnInit {
    constructor(private contractService: ContractsDataService,
                private route: ActivatedRoute,
                private modalService: NgbModal) {
    }

    contractId: string;
    contractData: ContractModel;
    isLoaded = false
    client: any = {};
    invoice: any = {};
    products: any = [];
    billNumber: string;
    paymentObject: any = {};
    paymentType: string = undefined;
    paymentDate: string;
    paymentAmount: string;
    billEmit: boolean;
    billPayed: string;

    getContractData() {
        this.route.params.subscribe(res => {
            this.contractId = res.id;
            this.contractService.viewContract(this.contractId).subscribe(contractData => {
                this.contractData = contractData;
                if(this.contractData.seriesName !== null && this.contractData.seriesNumber !== null) {
                    this.billEmit = true;
                }
                this.getPaymentStatus();
                this.isLoaded = true;
            })
        })

    }

    ngOnInit() {
        this.getContractData();

    }

    getPaymentStatus() {
        this.contractService.getPaymentStatus('RO13659420', this.contractData.seriesName, this.contractData.seriesNumber).subscribe(info => {
            if(info['paid'] === false && info['paidAmount'] === 0) {
                this.billPayed = "Neplatita"
            } else if (info['paid'] === true) {
                this.billPayed = "Incasata integral"
            } else {
                this.billPayed = "Incasata partial"
            }
            this.paymentAmount = info['unpaidAmount'];

        })
    }

    toSmartbill() {
        this.client.name = this.contractData.clientName;
        this.client.country = this.contractData.clientCountry;
        this.client.vatCode = this.contractData.clientFiscalCode;
        this.client.county = this.contractData.clientCity;
        this.client.address = this.contractData.clientAddress;

        for (var i = 0; i <  this.contractData.productList.length; i++) {
            var num =  this.contractData.productList[i];
            this.products.push({name:num.name, code:i, measuringUnitName:'buc', currency:'EUR', quantity: 1, price: num.price, isTaxIncluded: true, taxName: 'Normala', taxPercentage: 19 });
        }


        this.contractService.createBill(this.client, this.products).subscribe(res => {
            this.contractService.updateBillNumber(this.contractId, res['series'], res['number']).subscribe(resp=> {
                this.billEmit = true;
                this.getContractData();
            }, error => {
            });
        }, error => {
        })
    }

    downloadBill() {
        this.contractService.downloadFile('RO13659420', this.contractData.seriesName, this.contractData.seriesNumber).subscribe( (response: any) => {
            let fileName = 'Factura-' + this.contractData.seriesName + this.contractData.seriesNumber + '.pdf';
            let blob:any = new Blob([response], { type: 'text/json; charset=utf-8' });
            const url = window.URL.createObjectURL(blob);
            fileSaver.saveAs(blob, fileName);
        }, error => {
        })
    }

    openPayment(content) {
        this.modalService.open(content, { centered: true } );
    }


    payBill(type, date, value) {

        this.client.name = this.contractData.clientName;
        this.client.country = this.contractData.clientCountry;
        this.client.vatCode = this.contractData.clientFiscalCode;
        this.client.county = this.contractData.clientCity;
        this.client.address = this.contractData.clientAddress;

        this.invoice = [
            {
                seriesName: this.contractData.seriesName,
                number:this.contractData.seriesNumber
            }
        ]

        this.paymentObject['companyVatCode'] = 'RO13659420';
        this.paymentObject['value'] = value;
        this.paymentObject['type'] = type;
        this.paymentObject['issueDate'] = date;
        this.paymentObject.client = this.client;
        this.paymentObject.invoicesList = this.invoice;


        this.contractService.payBill(this.paymentObject).subscribe(resp => {
            this.getPaymentStatus();
            this.paymentType = undefined;
            this.paymentDate = '';
        }, error => {
            this.getPaymentStatus();
        })
    }

    generatePdf() {
        const documentDefinition = this.getDocumentDefinition();
        pdfMake.createPdf(documentDefinition).open();
    }

    enumPipe = new EnumTransformPipe();

    getDocumentDefinition() {
        return {
            info: {
                title: 'ABJ-CONTRACT',
                author: 'AgribusinessJob'
            },
            // watermark: { text: 'www.agribusinessjob.ro', color: 'green', opacity: 0.1, bold: true, italics: false },
            footer: function(currentPage, pageCount) {
                return [
                    {
                        text: currentPage.toString() + ' din ' + pageCount, alignment: 'center', opacity: 0.5
                    }]},
            // header: function() {
            //     return [
            //         {text: 'Contract generat prin intermediul site-ului www.agribusinessjob.ro', alignment: 'center', opacity: 0.5, margin: [0, 15, 0, 10]}
            //     ]
            // },
            content: [
                {
                    text: 'Contract - ' + this.contractData.docNumber,
                    style: 'bigTitle'
                },
                {
                    columns:
                        [
                        [
                            {
                                text: 'Detalii Contract',
                                style: 'mediumTitle'
                            },
                            {
                                text: 'Nume: ' + this.contractData.name
                            },
                            {
                                text: 'Nr. contract: ' + this.contractData.docNumber
                            },
                            {
                                text: 'Date: ' + this.contractData.contractDate
                            },
                            {
                                text: 'Deadline: ' + this.contractData.deadline
                            },
                            {
                                text: 'Status: ' + this.enumPipe.transform(this.contractData.status)
                            },
                        ], [
                            {
                                text: 'Detalii Client',
                                style: 'mediumTitle'
                            },
                            {
                                text: 'Nume: ' + this.contractData.clientName
                            },
                            {
                                text: 'CIF: ' + this.contractData.clientFiscalCode
                            },
                            {
                                text: 'Adresa: ' + this.contractData.clientAddress + ', ' + this.contractData.clientCity + ', ' + this.contractData.clientCountry
                            },

                        ]],
                    // optional space between columns
                    columnGap: 10
                },
                {
                    columns: [
                        [
                            {
                                text: 'Lista produse',
                                style: 'mediumTitle',
                                margin: [0, 30, 0, 5]
                            },
                            this.getProductsObject(this.contractData.productList)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                text: 'Lista notite',
                                style: 'mediumTitle',
                                margin: [0, 30, 0, 5]
                            },
                            this.getNotesObject(this.contractData.personalNotes)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                text: 'Alte observatii',
                                style: 'mediumTitle',
                                margin: [0, 30, 0, 5]
                            },
                            {
                                text: this.contractData.observation
                            }
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                text: 'TOTAL',
                                style: 'totalTitle'
                            },
                            {
                                text: this.contractData.totalPrice + ' Euro',
                                style: 'totalSum'
                            }
                            ]
                    ]
                },

            ],
            styles: {
                mediumTitle: {
                    fontSize: 14,
                    bold: true,
                    margin: [0,0,0,5]
                },
                bigTitle: {
                    bold: true,
                    fontSize: 20,
                    margin: [0, 0, 0, 30],
                    alignment: 'center'
                },
                totalTitle: {
                    bold: true,
                    fontSize: 20,
                    margin: [0, 30, 0, 5],
                    decoration: 'underline',
                    alignment: 'right'
                },
                totalSum: {
                    bold: true,
                    fontSize: 20,
                    alignment: 'right'
                }
            },
        };
    }

    getProductsObject(products: ProductListModel[]) {
        if (this.contractData.productList != null) {
            return {
                table: {
                    widths: ['*', '*'],
                    body: [
                        [{
                            text: 'Nume produs',
                            style: 'tableHeader'
                        },
                            {
                                text: 'Pret',
                                style: 'tableHeader'
                            }
                        ],
                        ...products.map(ed => {
                            return [ed.name,
                                ed.price];
                        })
                    ]
                }
            };
        }
    }

    getNotesObject(notes: NotesListModel[]) {
        if (this.contractData.productList != null) {
            return {
                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [{
                            text: 'Autor',
                            style: 'tableHeader'
                        },
                            {
                                text: 'Nota',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Data',
                                style: 'tableHeader'
                            }
                        ],
                        ...notes.map(ed => {
                            return [ed.authorName,
                                ed.note,
                            ed.date];
                        })
                    ]
                }
            };
        }
    }

}
